// Quran.com v4 API service
const BASE = 'https://api.quran.com/api/v4';
const AUDIO_BASE = 'https://verses.quran.com';

// Translation IDs (verified working on api.quran.com v4)
export const TRANSLATIONS = {
  en: 20,    // Saheeh International (was 131 — retired)
  fr: 136,   // French — Muhammad Hamidullah
  es: 83,    // Spanish
  ur: 97,    // Urdu — Maulana Fateh Muhammad Jalandhry
};

// Reciter map — only use verified slugs on verses.quran.com
export const RECITERS = {
  7:  { name: 'Mishary Alafasy',  slug: 'Alafasy',             nameAr: 'مشاري العفاسي' },
  1:  { name: 'Abdul Basit',      slug: 'AbdulBaset/Murattal', nameAr: 'عبد الباسط' },
};

export const DEFAULT_RECITER = 7;

/** Get audio URL directly — no API call needed */
export const getAudioUrl = (verseKey, reciterId = DEFAULT_RECITER) => {
  const [c, v] = verseKey.split(':');
  const ch = c.padStart(3, '0');
  const vs = v.padStart(3, '0');
  const r = RECITERS[reciterId];
  if (!r) return null;
  return `${AUDIO_BASE}/${r.slug}/mp3/${ch}${vs}.mp3`;
};

/** Fetch all 114 chapters — with localStorage offline fallback */
export const fetchChapters = async () => {
  const cacheKey = 'quran_chapters';
  try {
    const res = await fetch(`${BASE}/chapters?language=en`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Failed to fetch chapters');
    const { chapters } = await res.json();
    try { localStorage.setItem(cacheKey, JSON.stringify({ chapters, ts: Date.now() })); } catch {}
    return chapters;
  } catch {
    const cached = localStorage.getItem(cacheKey);
    if (cached) return JSON.parse(cached).chapters;
    throw new Error('Chapters not available offline');
  }
};

/** Fetch verses for a chapter (paginated) — with localStorage offline fallback */
export const fetchVerses = async (chapterId, page = 1, language = 'en') => {
  const translationId = TRANSLATIONS[language] || TRANSLATIONS.en;
  const cacheKey = `quran_v_${chapterId}_${page}_${language}`;
  const url = `${BASE}/verses/by_chapter/${chapterId}?translations=${translationId}&per_page=50&page=${page}&fields=text_uthmani,verse_key`;

  try {
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`API ${res.status}`);
    const data = await res.json();
    // Cache for offline use
    try { localStorage.setItem(cacheKey, JSON.stringify({ data, ts: Date.now() })); } catch {}
    return data;
  } catch (err) {
    // Offline fallback — serve from localStorage cache
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const { data } = JSON.parse(cached);
      return { ...data, _fromCache: true };
    }
    throw err;
  }
};

/** Format verse key for display: "1:1" → "١:١" in Arabic */
export const formatVerseKey = (key, arabic = false) => {
  if (!arabic) return key;
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
  return key.replace(/\d/g, d => arabicDigits[d]);
};
